/**
 * @author Andrés Camilo Ferreira Rodríguez
 * @Copyright (c) Infotrack. All rights reserved.
 */
import notificacionGlobal from '@infotrack/presentacion-componentes/notificacionGlobal';
import ModeloReferencias from 'Infotrack@Modelos/smartStock/referencias';
import IFiltrosReferencias from 'Infotrack@Modelos/smartStock/referencias/entidades/filtrosReferencias';
import IReferencias from 'Infotrack@Modelos/smartStock/referencias/entidades/referencias';

export default class ControladorModeloReferencias {
    private modeloReferencias: ModeloReferencias;
    constructor() {
        this.modeloReferencias = new ModeloReferencias();
    }

    public consultarReferencias() {
        return this.modeloReferencias.consultarReferencias().then(({ data: { Entidades } }) => Entidades);
    }

    public async crearReferencias(referencias: IReferencias) {
        await this.modeloReferencias.crearReferencias(referencias);
    }

    public async editarReferencias(referencias: IReferencias) {
        await this.modeloReferencias.editarReferencias(referencias);
    }
    public async eliminarReferencias(referencias: IReferencias) {
        await this.modeloReferencias.eliminarReferencias(referencias);
    }

    public validarEntidad(referencias: IReferencias): boolean {
        if (referencias.ReferenciaDescripcion === '') {
            notificacionGlobal('Por favor ingrese todos los campos requeridos (*)', 6000, 'warning', true);
            return false;
        }
        return true;
    }

    public async consultarReferenciasPorFiltro(filtrosReferencias: IFiltrosReferencias) {
       return await (await this.modeloReferencias.consultarListaReferenciasPorFiltro(filtrosReferencias)).data.Entidades;
    }
}
